import { Slider } from "antd";
import { useState } from "react";

type CommitSliderProps = {
  value: number;
  onCommit: (val: number) => void;
  min: number;
  max: number;
  step: number;
  tooltip?: { formatter: (val: number | undefined) => string };
};

export const CommitSlider = ({
  value,
  onCommit,
  min,
  max,
  step,
  tooltip,
}: CommitSliderProps) => {
  const [localValue, setLocalValue] = useState(value);
  const [isDragging, setIsDragging] = useState(false);

  const displayValue = isDragging ? localValue : value;

  return (
    <Slider
      min={min}
      max={max}
      step={step}
      value={displayValue}
      onChange={(val) => {
        setIsDragging(true);
        setLocalValue(val);
      }}
      onChangeComplete={(val) => {
        setIsDragging(false);
        onCommit(val);
      }}
      tooltip={tooltip}
    />
  );
};
